import VueApexCharts from 'vue-apexcharts'
import moment from 'moment-timezone'
import codes from '@/f1/codes'

//i18n_data
// import _i18n_data from './i18n_data'
import i18n_data from '@/component/i18n_data';


export default {
  props: ['status', 'refresh_timer'],
  components: { VueApexCharts },
  watch : {
    status() {
      this.get()
    }
  },
  data : () => {
    return {
      codes,
      moment,
      total : 0,
      thumbnail_size: '100%',
      data_resource: [],
      options_resource: {
        labels: [],
        legend: { position: 'bottom', }
      },
      data_site: [],
      options_site: {
        labels: [],
        legend: { position: 'bottom', }
      },
      result : {},
      tmp_site : {},
      tmp_resource : {},
    }
  },

  computed: {
  },
  methods: {
    copy(task_key, page) {
      try {
        var tempElem = document.createElement('textarea');
        tempElem.value =`${task_key}|${page}`;
        document.body.appendChild(tempElem);
        tempElem.select();
        document.execCommand("copy");
        document.body.removeChild(tempElem);

        this.$toastr.i(`${i18n_data._i18n_info.ticket_copy[this.i18n]}`)

      } catch (e) { console.log(e); this.$toastr.i(`${i18n_data._i18n_info.copy_failed[this.i18n]}`) }
    },
    get() {
      try {
        this.result = Object.assign({}, this.result, this.status)
        this.total = 0
        this.data_resource = []
        this.data_site = []
        this.options_resource = Object.assign({}, { labels : [] })
        this.options_site = Object.assign({}, { labels : [] })

        Object.keys(this.result).forEach(x => {
          try {

            let key = x.replace("_qty", '')
            if(x.endsWith("_qty")) {
              this.tmp_site[key] = this.result[x]
              this.total += this.result[x]
            }
          } catch (e) { console.error(e) }
        })

        // site
        this.data_site.push(this.tmp_site.page - this.tmp_site.external)
        this.options_site.labels.push(`${i18n_data._i18n_msg.detect[this.i18n]}`)

        this.data_site.push(this.tmp_site.broken)
        this.options_site.labels.push(`${i18n_data._i18n_msg.error[this.i18n]}`)

        this.data_site.push(this.tmp_site.external)
        this.options_site.labels.push(`${i18n_data._i18n_msg.ext[this.i18n]}`)

        this.data_site.push(this.tmp_site.detect)
        this.options_site.labels.push(`${i18n_data._i18n_msg.detect[this.i18n]}`)

        // resource
        this.data_resource.push(this.tmp_site.page - this.tmp_site.external)
        this.options_resource.labels.push(`${i18n_data._i18n_msg.detect[this.i18n]}`)

        this.data_resource.push(this.tmp_site.resource)
        this.options_resource.labels.push(`${i18n_data._i18n_msg.resource[this.i18n]}`)

        if(this.total < 1) {
          this.data_site.push(100)
          this.data_resource.push(100)
          this.options_resource.labels.push(`${i18n_data._i18n_msg.inspection[this.i18n]}`)
          this.options_site.labels.push(`${i18n_data._i18n_msg.inspection[this.i18n]}`)
        }

        this.$toastr.s(`${i18n_data._i18n_success.load[this.i18n]}`)
      } catch(e) { console.log(e); this.$toastr.e(e.data ? e.data.message : e.statusText) }
    },
  },
  // watch: { '$route' (to, from) { console.log("from", from) } },
  created() { console.log('result.detail.vue', 'created'); },
  destroyed() { console.log('result.detail.vue', 'destroyed'); },
  mounted() { console.log('result.detail.vue', 'mounted'); this.get(); },
}
